<ng-container [matColumnDef]="columnName">
  <th mat-header-cell *matHeaderCellDef>
    #
  </th>

  <td mat-cell *matCellDef="let item; let i = index">
    {{ i + 1 }}
  </td>
</ng-container>
